/**
 * DUNAMIS WEAR — Conversion motion helpers
 * Horizontal scroll rows (manual drag/scroll only — no autoplay)
 */
(function () {
  'use strict';

  function initScrollRows() {
    document.querySelectorAll('[data-scroll-row]').forEach(function (wrap) {
      var row = wrap.querySelector('.gender-catalog__grid--scroll, .product-grid--slider-mobile');
      if (!row) return;

      function updateEdges() {
        var maxScroll = row.scrollWidth - row.clientWidth;
        if (maxScroll <= 8) {
          wrap.classList.remove('is-scrollable', 'is-scrolled-start', 'is-scrolled-end');
          return;
        }
        wrap.classList.add('is-scrollable');
        wrap.classList.toggle('is-scrolled-start', row.scrollLeft <= 8);
        wrap.classList.toggle('is-scrolled-end', row.scrollLeft >= maxScroll - 8);
      }

      row.addEventListener('scroll', updateEdges, { passive: true });
      window.addEventListener('resize', updateEdges, { passive: true });
      updateEdges();

      var isDragging = false;
      var startX = 0;
      var scrollLeft = 0;

      row.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        isDragging = true;
        startX = event.pageX - row.offsetLeft;
        scrollLeft = row.scrollLeft;
        row.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function () {
        isDragging = false;
        row.classList.remove('is-dragging');
      });

      row.addEventListener('mousemove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        var x = event.pageX - row.offsetLeft;
        row.scrollLeft = scrollLeft - (x - startX) * 1.2;
        updateEdges();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollRows);
  } else {
    initScrollRows();
  }
})();
